import React, { Fragment, useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom/dist";
import Swal from "sweetalert2";
import Table from "../../../core/pagination/datatable";
import { PlusCircle } from "feather-icons-react/build/IconComponents";
import { ErrorToaster } from "../../components/toaster/Toaster";
import StateServices from "../../../services/State";
import { deleteAlert } from "../../components/sweetAlert";
import StateForm from "../../../core/modals/inventory/stateform";
import { cleanObject, Debounce } from "../../../utils";

const States = () => {

  const [searchParams, setSearchParams] = useSearchParams();

  // *For Loader
  const [loader, setLoader] = useState(false);

  // *For States
  const [states, setStates] = useState([]);
  const [updateData, setUpdateData] = useState();

  // *For Pagination
  const [totalCount, setTotalCount] = useState(0);
  const currentPage = parseInt(searchParams.get("page") || "1", 10);
  const pageLimit = parseInt(searchParams.get("limit") || "10", 10);
  const searchText = searchParams.get("search") || "";

  // *For Get States
  const getStates = async (page = currentPage, limit = pageLimit) => {
    setLoader(true)
    try {
      const params = { ...Object.fromEntries(searchParams.entries()), page, limit }
      const { data, total_count } = await StateServices.getStates(params)
      setStates(data)
      setTotalCount(total_count)
    } catch (error) {
      ErrorToaster(error)
    } finally {
      setLoader(false)
    }
  }

  // *For Delete State
  const deleteState = async (id) => {
    try {
      const isConfirmed = await deleteAlert()

      if (isConfirmed) {
        await StateServices.deleteState(id);
        getStates();

        Swal.fire({
          title: "Deleted!",
          text: "Your file has been deleted.",
          icon: "success",
          confirmButtonText: "OK",
        });
      } else {
        Swal.close();
      }
    } catch (error) {
      ErrorToaster(error)
    }
  }

  const columns = [
    {
      title: "State",
      dataIndex: "name",
      sorter: (a, b) => a.name.length - b.name.length,
    },
    {
      title: "Sale Tax",
      dataIndex: "sales_tax",
      sorter: (a, b) => a.sales_tax.length - b.sales_tax.length,
    },
    {
      title: "Status",
      dataIndex: "is_active",
      render: (active) => (
        <Fragment>
          {active ? (
            <span className="badge badge-linesuccess">
              Active
            </span>
          ) : (
            <span className="badge badge-linedanger">
              Inactive
            </span>
          )}
        </Fragment>
      ),
      sorter: (a, b) => a.status.length - b.status.length,
    },
    {
      title: "Actions",
      dataIndex: "actions",
      key: "actions",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <Link
              className="me-2 p-2"
              to="#"
              data-bs-toggle="modal"
              data-bs-target="#open-modal"
              onClick={() => setUpdateData(record)}
            >
              <i data-feather="edit" className="feather-edit"></i>
            </Link>
            <Link className="confirm-text p-2" to="#" onClick={() => deleteState(record?.id)}>
              <i data-feather="trash-2" className="feather-trash-2"></i>
            </Link>
          </div>
        </div>
      ),
    },
  ];

  // *For Handle Pagination and Filters
  const handlePaginationFilter = (data) => {
    try {
      const updatedParams = {
        ...Object.fromEntries(searchParams.entries()),
        page: 1,
        ...cleanObject(data)
      };
      Debounce(() => setSearchParams(updatedParams));
    } catch (error) {
      console.log(' handlePaginationFilter => error:', error)
    }
  }

  useEffect(() => {
    getStates()
  }, [searchParams]);

  return (
    <Fragment>

      <StateForm getData={() => getStates()} updateData={updateData} resetUpdateData={() => setUpdateData()} />

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>State</h4>
                <h6>Manage your states</h6>
              </div>
            </div>
            <div className="page-btn">
              <Link
                to="#"
                className="btn btn-added"
                data-bs-toggle="modal"
                data-bs-target="#open-modal"
              >
                <PlusCircle className="me-2" />
                Add State
              </Link>
            </div>
          </div>
          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set">
                  <div className="search-input">
                    <input
                      type="text"
                      placeholder="Search"
                      defaultValue={searchText}
                      className="form-control form-control-sm formsearch"
                      onChange={(e) => handlePaginationFilter({ search: e.target.value })}
                    />
                    <Link to className="btn btn-searchset">
                      <i data-feather="search" className="feather-search" />
                    </Link>
                  </div>
                </div>
              </div>
              <div className="table-responsive">
                <Table
                  loading={loader}
                  columns={columns}
                  dataSource={states}
                  totalCount={totalCount}
                  pageSize={pageLimit}
                  currentPage={currentPage}
                  onChange={(page, pageSize) => handlePaginationFilter({ page: page, limit: pageSize })}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default States;
